import React from "react";

const InfoTip = ({ text }) => {
  return (
    <div className="relative group inline-block">
      <p className="text-black cursor-pointer text-[10px] font-semibold border border-gray-300 bg-gray-200 rounded-full w-4 h-4 flex items-center justify-center ml-1 ">
        i
      </p>

      {/* Tooltip */}
      <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-[180px] rounded-md bg-gray-100 text-black text-xs font-medium px-3 py-2 shadow-md opacity-0 group-hover:opacity-100 transition-all duration-300 z-10">
        {text}
        {/* Little pointer triangle */}
        <div className="absolute top-full left-1/2 -translate-x-1/2 w-2 h-2 bg-gray-100 rotate-45 -mt-1 shadow-md"></div>
      </div>
    </div>
  );
};

export default InfoTip;
